import type { EstadoTerceiraPortaOficina } from '../../dominio/didatico/oficinaTerceiraPorta'
import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { deArray, girarEmTorno, paraArray, somar, subtrair, vetor } from '../../dominio/geometria/vetor3'
import type { IdLadoTerceiraPorta } from './zonasOperacaoTerceiraPorta'

export const ABERTURA_RAD_TERCEIRA_PORTA = 0.95

export interface QuadroDaTerceiraPorta {
  origem: [number, number, number]
  giroY: number
}

export function quadroDaTerceiraPorta(
  perfil: PerfilVeiculo,
  lado: IdLadoTerceiraPorta,
  estado?: EstadoTerceiraPortaOficina,
): QuadroDaTerceiraPorta {
  const sinal = lado === 'esquerdo' ? 1 : -1
  return {
    origem: [sinal * (perfil.largura / 2 - 0.015), 0, perfil.portaTraseira.zDianteiro],
    giroY: (sinal < 0 ? ABERTURA_RAD_TERCEIRA_PORTA : -ABERTURA_RAD_TERCEIRA_PORTA) * (estado?.abertura ?? 0),
  }
}

export function posicaoNoQuadroDaTerceiraPorta(
  quadro: QuadroDaTerceiraPorta,
  canonica: [number, number, number],
): [number, number, number] {
  const origem = deArray(quadro.origem)
  return paraArray(somar(girarEmTorno(subtrair(deArray(canonica), origem), vetor(0, 1, 0), quadro.giroY), origem))
}

export function canonicaDoQuadroDaTerceiraPorta(
  quadro: QuadroDaTerceiraPorta,
  ponto: [number, number, number],
): [number, number, number] {
  const origem = deArray(quadro.origem)
  return paraArray(somar(girarEmTorno(subtrair(deArray(ponto), origem), vetor(0, 1, 0), -quadro.giroY), origem))
}
